import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	row1: {
		[theme.breakpoints.up("md")]: {
			alignItems: "center",
			display: "grid",
			gridGap: theme.spacing(3),
			gridTemplateColumns: "1fr 2fr",
			marginBottom: theme.spacing(8)
		},
		[theme.breakpoints.up("lg")]: {
			marginBottom: theme.spacing(11)
		}
	},
	headline: {
		fontFamily: "'Junicode'",
		fontSize: 34,
		letterSpacing: "-0.2px",
		lineHeight: 1.1,
		marginBottom: theme.spacing(6),
		[theme.breakpoints.up("md")]: {
			marginBottom: theme.spacing(0)
		},
		[theme.breakpoints.up("lg")]: {
			fontSize: 58,
			letterSpacing: "-0.4px",
			lineHeight: 1
		}
	},
	column2: {
		[theme.breakpoints.up("md")]: {
			marginLeft: "auto",
			maxWidth: 520
		}
	}
}));

export default styles;
